import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import configVars from "../../config";
import { getWithExpiry, setWithExpiry } from '../../common';
import DefaultImg from "./../../images/webinar-img.jpeg";

const Webinars = () => {

    const [webinars, setWebinars] = useState([]);
    const [currentMonth, setCurrentMonth] = useState('');
    const [monthsList, setMonthsList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {

        const savedWebinars = getWithExpiry('sy_webinars');
        const savedMonths = getWithExpiry('sy_webinar_months');

        if ( savedWebinars ) {

            setWebinars( savedWebinars );
            setMonthsList( savedMonths );

        } else {

            setIsLoading(true);

            (async () => {

                const response = await fetch(
                    `${configVars.apiUrl}wp/v2/webinar?per_page=100`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Basic ${configVars.auth}`,
                        },
                    }
                );
    
                const webinarResponse = await response.json();
    
                if ( webinarResponse ) {

                    let months = [];
    
                    let webinarsTemp = webinarResponse.map( (webinarItem) => {
                        
                        const webinarDate = new Date( webinarItem.date );
                        const monthName = new Intl.DateTimeFormat("sv-SV", { month: "long" }).format;
                        const dateWithMonth = `${monthName(webinarDate)} ${webinarDate.getFullYear()}`;
                        const dateFormatted = `${webinarDate.getMonth()+1}-${webinarDate.getFullYear()}`;
                        const dateFull = `${monthName(webinarDate)} ${webinarDate.getDate()}, ${webinarDate.getFullYear()}`;

                        if ( ! months.some(e => e.df === dateFormatted ) ) {
                            months.push( {
                                dwm: dateWithMonth,
                                df: dateFormatted
                            } );
                        }

                        return {
                            id: webinarItem.id,
                            slug: webinarItem.slug,
                            excerpt: webinarItem.excerpt,
                            date: {
                                gmt: webinarItem.modified_gmt,
                                dwm: dateWithMonth,
                                df: dateFormatted,
                                dfull: dateFull,
                            },
                            title:  webinarItem.title.rendered,
                            image: webinarItem.sy_fimg_url

                        };
                    } );
                    
                    setWithExpiry('sy_webinars', webinarsTemp);
                    setWithExpiry('sy_webinar_months',  months);
                    setWebinars( webinarsTemp );
                    setMonthsList( months );

                    setIsLoading(false);
                    //console.log( webinarResponse );
                }
    
            })()

        }

    }, []);

    return (
      <div className="webinars-wrap">
        {isLoading && (
          <div className="d-flex justify-content-center mt-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        {webinars.length > 0 && (
          <div className="d-flex flex-column flex-lg-row">
            <div
              className="webinar-btns-wrap ps-3 ps-lg-0 pe-3 pe-lg-5 "
              style={{ minWidth: "180px" }}
            >
              <div className="d-inline-block webinar-btn text-lg-end px-1 px-lg-0">
                <button
                  className={`btn btn-link px-0 ${
                    currentMonth === "" ? "text-primary" : "text-downriver"
                  }`}
                  onClick={() => setCurrentMonth("")}
                >
                  Alla
                </button>
              </div>

              {monthsList.map((month, index) => {
                return (
                  <div
                    className="d-inline-block webinar-btn text-lg-end px-1 px-lg-0"
                    key={index}
                  >
                    <button
                      className={`btn btn-link px-0 ${
                        currentMonth === month.df
                          ? "text-primary"
                          : "text-downriver"
                      }`}
                      onClick={() => setCurrentMonth(month.df)}
                    >
                      {month.dwm}
                    </button>
                  </div>
                );
              })}
            </div>
            <div
              className="webinar-items-wrap flex-grow-1"
              style={{ minWidth: "calc( 100% - 180px)" }}
            >
              <div className="category-posts-wrap px-3">
                <div className="row">
                  {webinars.map((webinar, index) => {
                    return (
                      <div
                        className={`col-12 col-lg-6 col-xl-4 mb-4 ${
                          !currentMonth || currentMonth === webinar.date.df
                            ? ""
                            : "d-none"
                        }`}
                        key={index}
                      >
                        <div className="card w-100 h-100 shadow">
                          <div
                            className="overflow-hidden position-relative"
                            style={{ height: "230px" }}
                          >
                            <Link
                              to={`/digitala-traffar/${webinar.id}`}
                              className="text-decoration-none h-100 d-flex"
                            >
                              <img
                                src={webinar.image ? webinar.image : DefaultImg}
                                className="card-img-top"
                                style={{ objectFit: "cover" }}
                                alt={webinar.title}
                              />
                            </Link>
                          </div>
                          <div className="card-body">
                            <Link
                              to={`/digitala-traffar/${webinar.id}`}
                              className="text-downriver text-decoration-none"
                            >
                              <h3
                                className="card-title mb-0"
                                dangerouslySetInnerHTML={{
                                  __html: webinar.title,
                                }}
                              ></h3>
                            </Link>
                            <div className="webinar-meta mb-2">
                              <span className="font-size-medium">
                                {webinar.date.dfull}
                              </span>
                            </div>
                            <p
                              className="card-text border-top pt-2"
                              dangerouslySetInnerHTML={{
                                __html: webinar.excerpt,
                              }}
                            ></p>
                            <div className="text-end">
                              <Link
                                to={`/digitala-traffar/${webinar.id}`}
                                className="text-secondary"
                              >
                                <span className="pe-2">Läs mer</span>
                                <i
                                  className="fa fa-angle-double-right"
                                  aria-hidden="true"
                                ></i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );

}

export default Webinars;